import { Injectable, NgZone } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpService } from './../services/http.service';
import { Observable, of } from 'rxjs';
import { Globals } from '../models/globals.model';
import { SseService } from './sse-service';

@Injectable({
  providedIn: 'root'
})
export class MLService {

  apiUri: string;
  graphUri: string;
  flowsheetUri: string;
  createMLWorkspace = 'AML/CreateAMLWorkspace';
  locationApi = 'Azure/GetAllRegions';
  saveModelMasterDataApi = 'api/SaveModelMasterData';
  getModelListApi = 'api/ListModel';
  getModelParametersApi = 'api/GetModelParameter';
  getConfigParameters = 'api/GetModelParameter';
  getDataSourcesApi = 'api/FlowsheetBuilder/GetDataSources';
  getDataSourceParametersApi = 'api/FlowsheetBuilder/GetDataSourceParameters';

  constructor(private readonly httpService: HttpService, private readonly globals: Globals, private readonly http: HttpClient,
    private readonly _zone: NgZone, private readonly _sseService: SseService) {
    this.apiUri = this.globals.config.platformAdminApi_client_resourceUri;
    this.graphUri = this.globals.config.graphApi_client_resourceUri;
  }

  getConfigParameter(name, version) {
    return this.http.get(this.apiUri + this.getConfigParameters + '/' + name + '/' + version);
  }
  
  getLocations() {
    return this.http.get(this.apiUri + this.locationApi);
  }

  CreateMLWorkspace(worksapceDetail) {
    return this.http.post(this.apiUri + this.createMLWorkspace, worksapceDetail);
  }

  saveModelMasterData(modelMasterData) {
    return this.http.post(this.apiUri + this.saveModelMasterDataApi, modelMasterData);
  }

  getModelList() {
    return this.http.get(this.apiUri + this.getModelListApi);
  }

  getModelParameters(modelId) {
    return this.http.get(this.apiUri + this.getModelParametersApi + '/' + modelId);
  }

  getDataSources() {
    return this.http.get(this.flowsheetUri + this.getDataSourcesApi);
  }

  getDataSourceParameters(dataSourceId) {
    const params = { dataSourceId: dataSourceId };
    return this.http.get(this.flowsheetUri + this.getDataSourceParametersApi, {
      params: params
    });
  }

  redirectTo(url) {
    window.location.href = url;
  }
}
